import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideExpenseDetails,
  hideOrdersStatus,
} from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import price from "../../../Assets/images/price.png";
import { CompleteImg, IncompleteImg, WaitingImg } from "../../svg";
import { useEffect } from "react";
import { PersonalPaper, PopPID } from "../../guarantor/PersonalPaper";
import { openPop } from "../../../utilities/helper";
import Back from "../../../Assets/images/back.svg";
import FullScreen from "../../../Assets/icons/full screen.svg";

const ShowOrderStatus = ({ type }) => {
  const [color, setColor] = useState("");
  const [orderStatustext, setOrderStatustext] = useState("");

  const viewPupup = useSelector((state) => state.toggleState.value.orderStatus);
  const dispatch = useDispatch();

  const hidePupup = () => {
    dispatch(hideOrdersStatus());
  };
  // handel data form

  const [values, setValues] = useState({
    photo: "",
    viewPhoto: "",
    users: [],
    en_name: "",
    ar_name: "",
  });

  useEffect(() => {
    switch (type) {
      case "COMPLETE":
        setColor("green");
        setOrderStatustext("تــــــــــــم");
        break;
      case "INCOMPLETE":
        setColor("red");
        setOrderStatustext("لــــم يتم ");

        break;
      case "WAIT":
        setColor("orange");
        setOrderStatustext("قيد الانتظار");
        break;
      default:
        setColor("");
    }
  }, [type]);
  return (
    <Popup viewPupup={viewPupup} hidePupup={hidePupup} viewWidth="content-xl">
      <form className="main-contnt">
        <div className="head-content">
          <div className="view-img">
            {type === "COMPLETE" && <CompleteImg />}
            {type === "INCOMPLETE" && <IncompleteImg />}
            {type === "WAIT" && <WaitingImg />}
          </div>
        </div>
        <div className="body-content">
          <div className="show-details">
            <div className="item-details">
              <h3> حـالة الطـــــــــــــــــلب :</h3>
              <p class={`status-btn  status-btn--${color}`}>
                {" "}
                {orderStatustext}
              </p>
            </div>
            {type === "INCOMPLETE" && (
              <ItemDetails
                label="الســـــــــــــــــــــــــبب"
                value="موعد الحجز لم يكن متاح لدينا"
              />
            )}

            {ItemDetailsData.map((item, key) => (
              <ItemDetails key={key} label={item.label} value={item.value} />
            ))}
            <div className="item-details">
              <h3> حــــــــالــــــــة الاوراق :</h3>
              <p class={`status-btn  status-btn--${color}`}>
                {" "}
                {orderStatustext}
              </p>
            </div>
            <div className="papers__container">
              <Paper label="الصورة الامامية" />
              <Paper label=" الصورة الخلفية" />
              <Paper label="  تاشيرة العامل / العاملة المنزلية" />
              <Paper label="اقامة العامل / العاملة المنزلية" />
            </div>
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default ShowOrderStatus;

const ItemDetails = ({ label, value }) => {
  return (
    <div className="item-details">
      <h3> {label} :</h3>
      <p> {value} </p>
    </div>
  );
};

const ItemDetailsData = [
  {
    label: "رقـــم الطــــــــــــــلب ",
    value: "#125364",
  },
  {
    label: " تاريــــخ الطــــــــــــلب  ",
    value: " 29 - 8 -2022",
  },
  {
    label: "  اســـم الكفيــــــــــل  ",
    value: "عبد الله سعد",
  },
  {
    label: "  اســـم السائــــــــق  ",
    value: "خدمات خاصة بالعمالة المنزلية",
  },
  {
    label: "  اقسام الخدمـــــــات   ",
    value: "خدمة توصيل من المنزل الي المطار.",
  },
  {
    label: "  اســــــــــم الخدمــــة  ",
    value: "خدمات خاصة بالعمالة المنزلية",
  },
  {
    label: "  سعر الخدمـــــــــــــة  ",
    value: "15 د.ك",
  },
  {
    label: "    سعر المدفــــــــــوع   ",
    value: "10 د.ك",
  },
  {
    label: "   عنوان المطــار  ( من )   ",
    value: "ش الرئيسي , الكويت",
  },
  {
    label: "   عنوان الكفيل ( الي )   ",
    value: "ش الرئيسي , الكويت",
  },
  {
    label: "   موعــــد الحجز    ",
    value: "2022/9/1  - 10:30 ص",
  },
];

const Paper = ({ label, color }) => {
  const [showId, setShowID] = useState(false);
  const [src, setSrc] = useState("");

  return (
    <>
      <div className="personal-paper__side">
        <div className="flex-between">
          <p className="mb__small">* {label} </p>
          <p class={`status-btn  status-btn--green`}>ok</p>
        </div>
        <div className="personal-id__box">
          <img
            src={Back}
            alt="id "
            className="personal-id__img"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </>
  );
};
